module.exports = __webpack_public_path__ + "static/media/alot-logo.8a3da7aa.svg";